// MSMEOtherGamesHome.jsx
import React, { useState } from 'react';
import MSMEAgriSoloSeedMatcher from './MSMEAgriSoloSeedMatcher';
import MSMETycoon from './MSMETycoon';
import MSMEQuest from './MSMEQuest';
import MSMEHarvestHeroes from './MSMEHarvestHeroes';
import MSMEOlympics from './MSMEOlympics';
import MSMEMetaverse from './MSMEMetaverse';

// Categories
const categories = [
  { id: 1, title: 'MSME Tycoon', desc: 'Run your own virtual farm economy and markets.', component: <MSMETycoon /> },
  { id: 2, title: 'Krishi Quest', desc: 'Adventure quests solving real farming problems.', component: <MSMEQuest/> },
  { id: 3, title: 'Harvest Heroes', desc: 'Seasonal crop competitions with challenges.', component: <MSMEHarvestHeroes/> },
  { id: 4, title: 'MSME Puzzle Mania', desc: 'Casual farm-themed match-3 puzzle game.', component: <MSMEAgriSoloSeedMatcher /> },
  { id: 5, title: 'MSME Olympics', desc: 'Mini skill challenges: ploughing, milking, tractor race.', component: <MSMEOlympics/> },
  { id: 6, title: 'MSME Metaverse', desc: 'Virtual farming village & trading hub.', component: <MSMEMetaverse/> },
];

export default function MSMEOtherGamesHome() {
  const [activeGame, setActiveGame] = useState(null);

  if (activeGame) {
    return (
      <div className="p-5 bg-black min-h-screen text-gray-300">
        <button
          onClick={() => setActiveGame(null)}
          className="mb-4 px-4 py-2 rounded-lg border border-green-500 text-green-500 hover:bg-green-500 hover:text-black transition"
        >
          ← Back to Games Home
        </button>
        {activeGame.component}
      </div>
    );
  }

  return (
    <div className="bg-black min-h-screen p-5 flex flex-col items-center text-gray-300">
      <h1 className="text-2xl font-bold mb-4 text-gray-300">🎮 Think5Whys MSME Games</h1>

      <div className="grid gap-4 w-full max-w-5xl sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {categories.map(cat => (
          <div
            key={cat.id}
            className="flex flex-col justify-between bg-gray-900 rounded-xl p-4 shadow-md hover:shadow-lg transition"
          >
            <h3 className="text-lg font-semibold text-gray-100 mb-2">{cat.title}</h3>
            <p className="text-sm text-gray-400 flex-grow mb-4">{cat.desc}</p>
            {cat.component ? (
              <button
                onClick={() => setActiveGame(cat)}
                className="mt-auto px-4 py-2 rounded-lg bg-green-600 text-black font-semibold hover:bg-green-500 transition"
              >
                ▶ Play
              </button>
            ) : (
              <button
                disabled
                className="mt-auto px-4 py-2 rounded-lg bg-gray-700 text-gray-500 cursor-not-allowed"
              >
                Coming Soon
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
